<template>
    <div class="wrapper blog-post">
        <div class="page-header page-header-small" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img5') + ')' }"></parallax>
        </div>
        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-200%); line-height: normal;">nosotros.json->mensajes:img5</span>
        
        <div class="page-head2 page-header-mini" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h3 class="title">{{mensaje('tit10')}}</h3>
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-200%); line-height: normal;">nosotros.json->mensajes:tit10</span>
                    <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,50%); line-height: normal;">nosotros.json->mensajes:men10 <i>HTML</i></span>
                    <p v-html="mensaje('men10')"></p>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import { Card, Button, Comment, Badge, InfoSection, Checkbox } from '@/components';
  import {RUTA_BASE} from '@/constants'
  import axios from "axios"

  export default {
    name: 'terminos',
    bodyClass: 'blog-post',
    components: {
      Card,
      InfoSection,
      Badge,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        mensajes: [],
        headerSimple: false,
        logo_altura: 0,

      }
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/nosotros'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.mensajes
        })
        .catch(error => console.log(error))
      },
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      }
    },
    mounted() {
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      this.headerSimple = this.$store.state.header_simple
      this.logo_altura = this.$store.state.logo_altura
      var cadJson = 'json/nosotros'+numIdioma.toString()+'.json'
      axios.get(RUTA_BASE+cadJson)
      .then(response => {
          this.mensajes = response.data.mensajes
      })
      .catch(error => console.log(error))
    }
  }
</script>
<style>
</style>
